"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports._connectToContracts = exports._assetTokenIsMock = exports._priceFeedIsTestnet = exports._LiquityContract = void 0;
const contracts_1 = require("@ethersproject/contracts");
const ActivePool_json_1 = __importDefault(require("../abi/ActivePool.json"));
const AdminContract_json_1 = __importDefault(require("../abi/AdminContract.json"));
const BorrowerOperations_json_1 = __importDefault(require("../abi/BorrowerOperations.json"));
const CollSurplusPool_json_1 = __importDefault(require("../abi/CollSurplusPool.json"));
const SLSDToken_json_1 = __importDefault(require("../abi/SLSDToken.json"));
const DefaultPool_json_1 = __importDefault(require("../abi/DefaultPool.json"));
const PSYParameters_json_1 = __importDefault(require("../abi/PSYParameters.json"));
const GasPool_json_1 = __importDefault(require("../abi/GasPool.json"));
const HintHelpers_json_1 = __importDefault(require("../abi/HintHelpers.json"));
const MultiTroveGetter_json_1 = __importDefault(require("../abi/MultiTroveGetter.json"));
const PriceFeed_json_1 = __importDefault(require("../abi/PriceFeed.json"));
const PriceFeedTestnet_json_1 = __importDefault(require("../abi/PriceFeedTestnet.json"));
const SortedTroves_json_1 = __importDefault(require("../abi/SortedTroves.json"));
const StabilityPool_json_1 = __importDefault(require("../abi/StabilityPool.json"));
const StabilityPoolManager_json_1 = __importDefault(require("../abi/StabilityPoolManager.json"));
const IERC20_json_1 = __importDefault(require("../abi/IERC20.json"));
const ERC20Mock_json_1 = __importDefault(require("../abi/ERC20Mock.json"));
const TroveManager_json_1 = __importDefault(require("../abi/TroveManager.json"));
const TroveManagerHelpers_json_1 = __importDefault(require("../abi/TroveManagerHelpers.json"));
const buildEstimatedFunctions = (estimateFunctions, functions) => Object.fromEntries(Object.keys(estimateFunctions).map(functionName => [
    functionName,
    async (overrides, adjustEstimate, ...args) => {
        if (overrides.gasLimit === undefined) {
            const estimatedGas = await estimateFunctions[functionName](...args, overrides);
            overrides = {
                ...overrides,
                gasLimit: adjustEstimate(estimatedGas)
            };
        }
        return functions[functionName](...args, overrides);
    }
]));
class _LiquityContract extends contracts_1.Contract {
    constructor(addressOrName, contractInterface, signerOrProvider) {
        super(addressOrName, contractInterface, signerOrProvider);
        // this.estimateAndCall = buildEstimatedFunctions(this.estimateGas, this);
        this.estimateAndPopulate = buildEstimatedFunctions(this.estimateGas, this.populateTransaction);
    }
    extractEvents(logs, name) {
        return logs
            .filter(log => log.address === this.address)
            .map(log => this.interface.parseLog(log))
            .filter(e => e.name === name);
    }
}
exports._LiquityContract = _LiquityContract;
/** @internal */
const _priceFeedIsTestnet = (priceFeed) => "setPrice" in priceFeed;
exports._priceFeedIsTestnet = _priceFeedIsTestnet;
/** @internal */
const _assetTokenIsMock = (assetToken) => "mint" in assetToken;
exports._assetTokenIsMock = _assetTokenIsMock;
const getAbi = (priceFeedIsTestnet, assetTokenIsMock) => ({
    activePool: ActivePool_json_1.default,
    adminContract: AdminContract_json_1.default,
    borrowerOperations: BorrowerOperations_json_1.default,
    collSurplusPool: CollSurplusPool_json_1.default,
    defaultPool: DefaultPool_json_1.default,
    gasPool: GasPool_json_1.default,
    hintHelpers: HintHelpers_json_1.default,
    multiTroveGetter: MultiTroveGetter_json_1.default,
    priceFeed: priceFeedIsTestnet ? PriceFeedTestnet_json_1.default : PriceFeed_json_1.default,
    psyParameters: PSYParameters_json_1.default,
    sfrxEthToken: assetTokenIsMock ? ERC20Mock_json_1.default : IERC20_json_1.default,
    slsdToken: SLSDToken_json_1.default,
    sortedTroves: SortedTroves_json_1.default,
    stabilityPoolManager: StabilityPoolManager_json_1.default,
    stabilityPoolSfrxEth: StabilityPool_json_1.default,
    stabilityPoolWstEth: StabilityPool_json_1.default,
    troveManager: TroveManager_json_1.default,
    troveManagerHelpers: TroveManagerHelpers_json_1.default,
    wstEthToken: assetTokenIsMock ? ERC20Mock_json_1.default : IERC20_json_1.default,
});
const mapLiquityContracts = (contracts, f) => Object.fromEntries(Object.entries(contracts).map(([key, t]) => [key, f(t, key)]));
/** @internal */
const _connectToContracts = (signerOrProvider, { addresses, _priceFeedIsTestnet, _assetTokenIsMock }) => {
    const abi = getAbi(_priceFeedIsTestnet, _assetTokenIsMock);
    return mapLiquityContracts(addresses, (address, key) => new _LiquityContract(address, abi[key], signerOrProvider));
};
exports._connectToContracts = _connectToContracts;
//# sourceMappingURL=contracts.js.map